module.exports = __webpack_public_path__ + "static/media/cafe24-order-integration.5f02ffc8.png";